import React from "react";
import { t } from "ttag";

import { Modal } from "../../../common/Modal";
import { IModularConfiguratorOptionSet } from "../models.interfaces";
import { RootProductCompareModalContent } from "./RootProductCompareModalContent";

import styles from "./RootProductCompareModal.module.scss";

interface IProps {
    optionSet: IModularConfiguratorOptionSet;
}

interface IState {
    isOpen: boolean;
}

// TODO(ssr, LEVEL 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to 67 LOC, simple modal state management (isOpen), basic open/close handlers, and straightforward Modal component integration.
export class RootProductCompareModal extends React.PureComponent<
    IProps,
    IState
> {
    public state: IState = {
        isOpen: false,
    };

    private readonly onOpen = (
        e: React.MouseEvent<HTMLButtonElement>,
    ): void => {
        e.preventDefault();
        this.setState({
            isOpen: true,
        });
    };

    private readonly onRequestClose = (): void => {
        this.setState({
            isOpen: false,
        });
    };

    render(): React.JSX.Element | null {
        if (!this.props.optionSet.root_product_compare_modal) {
            return null;
        }
        return (
            <>
                <button className={styles.openBtn} onClick={this.onOpen}>
                    {t`Compare`}
                </button>
                <Modal
                    isOpen={this.state.isOpen}
                    onRequestClose={this.onRequestClose}
                    className={styles.modalContent}
                    aria={{
                        // TODO(i18n): This ID reference "heading" should correspond to a translatable heading element
                        labelledby: "heading",
                    }}
                >
                    <RootProductCompareModalContent
                        optionSet={this.props.optionSet}
                    />
                </Modal>
            </>
        );
    }
}
